import { gql } from '@provision/graphql-client';
import { WORKFLOW_FIELDS, WORKFLOW_VERSION_FIELDS } from './workflow.fragments';

export const CREATE_DRAFT_WORKFLOW_VERSION_MUTATION = gql`
  mutation CreateDraftWorkflowVersion($input: CreateDraftWorkflowVersionInput!) {
    createDraftWorkflowVersion(input: $input) {
      workflowId
      workflowVersionId
      version
    }
  }
`;

export const CHANGE_WORKFLOW_VERSION_ACTIVE_STATE_MUTATION = gql`
  mutation ChangeWorkflowVersionActiveState($input: ChangeWorkflowVersionActiveStateInput!) {
    changeWorkflowVersionActiveState(input: $input) {
      workflowId
      workflowVersionId
      active
    }
  }
`;

export const SOFT_DELETE_WORKFLOW_VERSION_MUTATION = gql`
  mutation SoftDeleteWorkflowVersion($input: SoftDeleteWorkflowVersionInput!) {
    softDeleteWorkflowVersion(input: $input)
  }
`;

export const SET_WORKFLOW_ASSIGNMENT_MUTATION = gql`
  mutation SetWorkflowAssignment($input: SetWorkflowAssignmentInput!) {
    setWorkflowAssignment(input: $input) {
      partnerId
      triggerType
      workflowId
    }
  }
`;

export const CREATE_WORKFLOW_WITH_FIRST_VERSION_MUTATION = gql`
  ${WORKFLOW_FIELDS}
  ${WORKFLOW_VERSION_FIELDS}
  mutation CreateWorkflowWithFirstVersion($input: CreateWorkflowWithFirstVersionInput!) {
    createWorkflowWithFirstVersion(input: $input) {
      workflowId
      workflowVersionId
      version
      workflow {
        ...WorkflowFields
      }
      workflowVersion {
        ...WorkflowVersionFields
      }
    }
  }
`;
